import type { SVGProps } from "react";

/**
 * The launcher's glyphs: filled Phosphor icons (the widget's icon language),
 * inlined from the Phosphor core set (`assets/fill/*.svg`, MIT) until the
 * button needs enough of them to add `@phosphor-icons/react`.
 */
/** Phosphor `arrow-right`, bold weight: the join CTA's "go" (a bare arrow —
 *  Sebastian: "an arrow only, not in a circle"). A direction glyph
 *  (`igw-dir`): on the mirrored side it points the way the button grows,
 *  where every other sign turns back upright. */
export const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    {...props}
    className={["igw-dir", props.className].filter(Boolean).join(" ")}
  >
    <path d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z" />
  </svg>
);

/** Phosphor `caret-right`, bold weight: the switch chip's "next". */
export const CaretIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" />
  </svg>
);

/** Phosphor `hourglass-high`, fill weight: running out (a prize-drop tier's
 *  last few — urgency is never colour alone, D-087). */
export const HourglassIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M200,75.64V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.07,16.07,0,0,0,6.4,12.8L114.67,128,62.4,167.2A16.07,16.07,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.36a16.09,16.09,0,0,0-6.35-12.77L141.27,128l52.38-39.59A16.09,16.09,0,0,0,200,75.64ZM184,40V64H72V40Zm0,176H72V180l56-42,56,42.35Z" />
  </svg>
);
